import { render } from "./servicesList.vue?vue&type=template&id=11212436&scoped=true"
import script from "./servicesList.vue?vue&type=script&lang=js"
export * from "./servicesList.vue?vue&type=script&lang=js"

import "./servicesList.vue?vue&type=style&index=0&id=11212436&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11212436"]])

export default __exports__